const app_base_url = "/login-unico";
const site_sinsoft_url = "https://sinsoft.com.br/";
//const api_login_unico_url = "http://localhost:50";
const api_login_unico_url = "https://solucoes.sinsoft.com.br/api/login-unico/"
const api_enderecos = "https://solucoes.sinsoft.com.br/api/enderecos/"

const login_unico_app = "https://solucoes.sinsoft.com.br/login-unico/";
//APLICATIVOS EXTERNOS
//const api_protocolo_url = "http://localhost:3156";
const api_protocolo_url = "https://solucoes.sinsoft.com.br/api/protocolo";


export { app_base_url, site_sinsoft_url, api_login_unico_url, api_enderecos, api_protocolo_url,login_unico_app }